import './CardColumn.scss';
import Checkbox from '@/components/UI/FormElements/Checkbox';
import { _isNotEmpty } from '@/littledash';
import type { DroppableProvidedProps } from '@hello-pangea/dnd';
import cn from 'classnames';
import { FC, ReactNode, ChangeEvent, Children } from 'react';

interface CardColumnProps {
  children: ReactNode;
  className?: string;
  title: ReactNode | string;
  footer?: ReactNode;
  placeholderCard?: ReactNode;
  isSelectable?: boolean;
  hasSpace?: boolean;
  onSelect?: (e: ChangeEvent<HTMLInputElement>) => void;
  actionMenu?: ReactNode;
  innerRef?: (element: HTMLElement | null) => void;
  droppableProps?: DroppableProvidedProps;
  isOver?: boolean;
  droppablePlaceholder?: ReactNode;
}

const CardColumn: FC<CardColumnProps> = ({
  children,
  className,
  title,
  footer,
  placeholderCard,
  isSelectable,
  hasSpace = true,
  onSelect,
  actionMenu,
  innerRef,
  droppableProps,
  isOver = false,
  droppablePlaceholder,
}) => {
  const childArray = Children.toArray(children).filter(Boolean);
  const hasChildren = _isNotEmpty(childArray);

  const emptyPlaceholder = placeholderCard ? (
    <div style={{ opacity: 0, height: 90 }}>{placeholderCard}</div>
  ) : (
    <div style={{ width: '100%', height: '200px' }} />
  );

  return (
    <div
      ref={innerRef}
      {...(droppableProps ?? {})}
      className={cn(
        'overflow-hidden ba bg-light-silver br2',
        className,
        isOver && hasSpace ? 'b--blue' : 'b--moon-gray'
      )}
    >
      <div className={'flex flex-row bg-white pa2 justify-between'} style={{ height: '38px' }}>
        <div className={'flex flex-row items-center'}>
          {isSelectable === true && (
            <Checkbox className={'dib mr2'} name={`${title}-checkbox`} id={`${title}-checkbox`} onChange={onSelect} />
          )}
          <span className={'f5 lh-title'}>{title}</span>
        </div>
        {actionMenu && <div>{actionMenu}</div>}
      </div>
      <div className={cn('card-column-content', { pa2: hasChildren })}>
        {hasChildren ? children : emptyPlaceholder}
        {droppablePlaceholder}
      </div>
      <div className={cn('bg-white pa2', { ui__disabled: !hasSpace })}>{footer}</div>
    </div>
  );
};

export default CardColumn;
